import React from 'react';
import { Eyebrow } from './Eyebrow';
import { Reveal } from './Reveal';
import type { PillarPageContent } from '../types/pillarPage';
type PathSectionProps = {
  content: PillarPageContent['path'];
};
export function PathSection({
  content
}: PathSectionProps) {
  return <section className="w-full border-y border-accent-deep/40 bg-surface/40 py-28 lg:py-40" data-id="element-173" data-mp="p6gmaqxbd29a">
      <div className="mx-auto grid w-full max-w-[1240px] grid-cols-1 gap-14 px-6 sm:px-10 lg:grid-cols-12 lg:gap-20" data-id="element-174" data-mp="p4nbr0jkxxw0">
        <div className="lg:col-span-5" data-id="element-175" data-mp="ywjn3daofki6">
          <Reveal data-id="element-176" data-mp="yvi14ds4hdlo">
            <Eyebrow data-id="element-177" data-mp="yw02tpxk0k0z">{content.eyebrow}</Eyebrow>
            <h2 className="mt-6 text-3xl font-extrabold leading-[1.1] tracking-[-0.025em] text-bone sm:text-4xl lg:text-[3rem]" data-id="element-178" data-mp="1cwkoctuusty6">
              {content.title}
            </h2>
            <div className="mt-8 space-y-5 text-[15px] leading-relaxed text-ash sm:text-base" data-id="element-179" data-mp="3enebc2768dg7">
              <p data-id="element-180" data-mp="39ob3k9zt3t4j">{content.paragraphs[0]}</p>
              <p className="text-bone" data-id="element-181" data-mp="39pcqpcu3k62m">{content.paragraphs[1]}</p>
            </div>
          </Reveal>
        </div>

        <ul className="lg:col-span-7" data-id="element-182" data-mp="1e891zcud81fs">
          {content.steps.map((step, i) => <Reveal as="li" key={step.label} delay={0.05 * i} data-id="element-183" data-mp="1j6u0n7tyyd24" data-mpi={i}>
              <div className="group flex items-baseline gap-6 border-b border-accent-deep/50 py-7 transition-colors duration-200 ease-elite hover:border-accent/40 sm:gap-10" data-id="element-184" data-mp="1n7mcm8u86w23">
                <span className="w-6 shrink-0 text-[11px] font-bold text-accent/50" data-id="element-185" data-mp="1rzxe3g4m6pwr">{`0${i + 1}`}</span>
                <div className="flex-1 sm:flex sm:items-baseline sm:gap-10" data-id="element-186" data-mp="1wzjolht25s1v">
                  <h3 className="w-44 shrink-0 text-[11px] font-bold uppercase tracking-label text-bone" data-id="element-187" data-mp="21uflav98p3lb">
                    {step.label}
                  </h3>
                  <p className="mt-3 text-[15px] leading-relaxed text-ash sm:mt-0" data-id="element-188" data-mp="2ax892oj7qx6e">{step.text}</p>
                </div>
              </div>
            </Reveal>)}
        </ul>
      </div>
    </section>;
}